import { AxiosError, HttpError } from "@bps/http-client";
import { createFeedbackStore } from "@bps/stores";

const getErrorMessage = (error: HttpError | AxiosError | string) => {
  if (error instanceof HttpError)
    return (error.detail as string) ?? error.message;
  if (error instanceof AxiosError) return error.message;
  return error;
};

export const useFeedbackStore = createFeedbackStore({
  parseError: getErrorMessage
});
